import { Controller } from "@hotwired/stimulus"
import { parseFiltersFromUrl } from "@/frontend/utils/searchHelpers"

const NOT_SURE_OPTION = "Not sure"
const ALL_OPTION = "All"
const SEARCH_FORM_MOBILE = "search_form_mobile"
const SEARCH_FORM_DESKTOP = "search_form_desktop"

export default class extends Controller {
  static targets = ["checkbox", "label", "dynamicLabel"]
  static values = {
    visibleLabels: { type: Number, default: 2 },
    type: { type: String, default: "Desktop" },
    dataAttributes: { type: String },
  }

  syncWithQuery() {
    this.element.querySelectorAll('input[type="checkbox"]').forEach((el) => {
      if (el.dataset.title === NOT_SURE_OPTION) return

      el.checked = parseFiltersFromUrl(location.pathname, el.name.slice(0, -2), el.value)
    })
    delete this.element.dataset.loading
  }

  toggle(e) {
    const { title, type } = e.target.dataset

    // Handle subfilters inside main categories as dimensions.
    if (type) {
      if (title.startsWith(ALL_OPTION)) {
        this.markAll(false, type)
        e.target.checked = true
      } else {
        this.checkboxTargets
          .filter((ch) => ch.dataset.type == type && ch.dataset.title.startsWith(ALL_OPTION))
          .map((el) => (el.checked = false))
      }
      this.updateCount()
      return
    }

    // Handle main filters as styles, sizes and budget.
    if (title === NOT_SURE_OPTION) {
      this.markAll(false, "ignore_typed")
      e.target.checked = true
      this.openNextFilter(this.element)
    } else if (title.startsWith(ALL_OPTION)) {
      this.markAll(false, "ignore_typed")
      e.target.checked = true
    } else {
      this.checkboxTargets
        .filter((ch) => {
          const { title: ch_title, type: ch_type } = ch.dataset
          return ch_title === NOT_SURE_OPTION || (ch_title.startsWith(ALL_OPTION) && !ch_type)
        })
        .map((el) => (el.checked = false))
    }
    this.updateCount()
  }

  updateCount() {
    const checkedCount = this.checkboxTargets.filter((ch) => ch.checked).length
    let label = this.checkboxTargets
      .filter((ch) => ch.checked)
      .map((el) => el.dataset.title)
      .slice(0, this.visibleLabelsValue)

    if (this.typeValue === "mobile") {
      const filters = label.map((el) => `<span class="bg-gray-100 px-6 py-2 rounded-full text-sm">${el}</span>`).join()
      label = `<span class="mr-5 font-euclid font-medium text-xl">Style:</span>${filters}`
    } else {
      label = label.join(" and ")
    }

    if (checkedCount > this.visibleLabelsValue) {
      label += `<div class="text-zinc-400 ml-4">+${checkedCount - this.visibleLabelsValue} More</div>`
    }

    const labelEl = this.labelTarget
    const dynamicLabelEl = this.dynamicLabelTarget

    if (checkedCount > 0) {
      labelEl.classList.add("hidden")
      dynamicLabelEl.innerHTML = label
      dynamicLabelEl.classList.remove("hidden")
    } else {
      labelEl.classList.remove("hidden")
      dynamicLabelEl.classList.add("hidden")
    }
  }

  markAll(value = true, type = null) {
    let targets

    if (type == "ignore_typed") {
      targets = this.checkboxTargets.filter((ch) => !ch.dataset.type)
    } else if (type) {
      targets = this.checkboxTargets.filter((ch) => ch.dataset.type == type)
    } else {
      targets = this.checkboxTargets
    }
    targets.map((el) => (el.checked = value))
  }

  onToggle(event) {
    // It needs to stop flickering separator on hover
    this.dataAttributesValue.split(" ").forEach((el) => {
      event.currentTarget.open
        ? this.element.setAttribute(`${el}-selected`, "")
        : this.element.removeAttribute(`${el}-selected`)
    })
  }

  openNextFilter(el) {
    let next = el.nextElementSibling

    if (next?.tagName === "DIV") return this.openNextFilter(next)

    if (next?.tagName === "DETAILS") {
      this.element.open = false
      next.open = true
      return
    } else {
      setTimeout(() => this.submitForm(), 500)
    }
  }

  submitForm() {
    const hasNotSure = [
      ...this.element.parentElement.querySelectorAll('div[data-search-filter-label-target="dynamicLabel"]'),
    ].every((el) => el.textContent.includes(NOT_SURE_OPTION))

    if (hasNotSure)
      document.getElementById(this.typeValue === "mobile" ? SEARCH_FORM_MOBILE : SEARCH_FORM_DESKTOP).submit()
  }
}
